module.exports = __webpack_public_path__ + "static/___003___Spacious-living-area-in-a-gated-environment.190c2089.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider/___003___Spacious-living-area-in-a-gated-environment.jpg
// module id = 1279
// module chunks = 64098118039141